import { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable";
import {  Row, Col, Container,Nav} from "react-bootstrap";
import  { generatePdf, exportToExcel } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import { Field, FormikProvider, Form, useFormik } from "formik";
export default function RoleIdserviceReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [searchText1, setSearch1] = useState("");
 const [activeTab, setActiveTab] = useState('roleservices');

 
  const formik = useFormik({
    initialValues: {
        role: ""
     
    },

  })
const [getdata, setgetdata] = useState([]);
const [roleslist, setroleslist] = useState([]);


 
 useEffect(() => {
        
        KpiService.rolessmaster().then((res) => {
             if (res.data) {
               let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
               setroleslist(options);
             }
           });

}, []);
  
const filteredDataa = searchText1.length > 0 && getdata?.length ? getdata.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText1.toLowerCase()) ); }) ); }) : getdata;

 const reloadservices =()=>{
  store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.reloadRoleServices()
.then((res) => {
  showAlertMessage(res.data,"success")
 }).finally(() => {
  store.dispatch({ type: "HIDE_SPINNER" });
});
}

 const reloadroleservices =(role)=>{
  store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.roleServicesByRoleId(role)
.then((res) => {
  if(res.data){
    setgetdata(res.data);
  }else {
        setgetdata([]);
      }
 }).catch((error) => {
  setgetdata([]);
  console.error("Error in populationReport:", error); 
}).finally(store.dispatch({ type: "HIDE_SPINNER" }));
}
  return (
    <>
      <Menubar />
      <Container fluid  className='map-header1'  >
        <div className='sa-title'>
          <h2>Load Services <span> Report</span></h2>
        </div>
      </Container>

      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="table-section-wrapper mt-2" style={{ textAlign: "center", }} >
                    
                                            <div className="Performancetabs">
                                                <Nav variant="pills" className="tabs-row d-flex flex-wrap justify-content-start gap-2 ">
                                                  
        
        <Col xxl={2} xl={2} lg={3} md={3} sm={12} xs={6} className="px-0" style={{ maxWidth: '140px' }}>
          <Nav.Item className={`tab-boxes tab-boxes2 ${activeTab === 'roleservices' ? 'dash-active-tab' : ''}`} onClick={() => { setActiveTab("roleservices") }} style={{ cursor: 'pointer', }} > <p>Role Based Services</p> </Nav.Item>
        </Col>
          <Col xxl={2} xl={2} lg={3} md={3} sm={12} xs={6} className="px-0" style={{ maxWidth: '140px' }}>
          <Nav.Item className={`tab-boxes tab-boxes1 ${activeTab === 'reloadservices' ? 'dash-active-tab' : ''}`} onClick={() => { setActiveTab("reloadservices");reloadservices() }} style={{ cursor: 'pointer', }}> <p>Reload Services</p> </Nav.Item>
        </Col>
                             
                                                </Nav>
                                            </div>
                                            </div>
        


             
            
{activeTab === "roleservices" &&<>
 <Row className="mt-4"><Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} ><label className="fw-bold">Role Id</label><Field component="select" name="role" className="form-control" onChange={(e)=>{reloadroleservices(e.target.value);formik.handleChange(e)}}><option value="">--Select--</option>{roleslist}</Field></Col>
 {/* <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} ><MuiButton type="button" onClick={() => {reloadroleservices(formik.values.role) }} color="error" variant="contained" size="small" className="text-end mt-4" > Get Data </MuiButton></Col> */}
</Row>
 <Row className="mt-3">
                    <Col xs={12} sm={12} lg={8} md={8} xl={8} xxl={8}>
 <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} >
                  <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText1} onChange={(e) => setSearch1(e.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div>
              </Col>

                 <Col className=" mb-2 " > <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "RoleServicesReport",3)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button> <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "RoleServicesReport")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
              
                                  </Col>
            </Row>
  <div id="table-scroll"className="table-scroll">
              <div className="table-wrap">
  <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" >
              
<thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                      <tr className="text-center">
                        <th colSpan={3} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
                          <span style={{ color: "black", fontSize: "15px" }}> Service Reload Report</span>
                        </th>
                      </tr>
                      <tr className="text-center">
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Sl.No.</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Service Id</th>
                        <th style={{ backgroundColor: "#4e835c", color: "#fff" }}>Service Mode</th>
                       
                      </tr>
                    </thead>

                  <tbody>
  {filteredDataa?.length === 0 ? (
    <tr>
      <td className="text-center" colSpan="3">
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    filteredDataa?.map((detail, i) => (
      <tr key={i}>
        <td style={{ textAlign: "center" }}>{i + 1}</td>
        <td style={{ textAlign: "center" }}>{detail.serviceId}</td>
        <td style={{ textAlign: "left" }}>
          {detail.serviceMode?.trim() ? detail.serviceMode : ""}
        </td>
      </tr>
    ))
  )}
</tbody>


              </table></div></div>
</Col></Row>
</>}


           </Form></FormikProvider>

<AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
      </Container >
    </>
  );
};



